// extracted by mini-css-extract-plugin
module.exports = {"stateView":"Unior_stateView__3jw1O","onDevice":"Unior_onDevice__1TUUu","offDevice":"Unior_offDevice__25fdK","alarm":"Unior_alarm__drSMx","basic":"Unior_basic__2fQpV"};